import $ from 'jquery';
import {kill} from './utilities';
import { emitter } from './emitter';
/**
 * The details section of the profile view
 *
 * @module profile-detail
 * @version 0.1.0
 * @author hello@bradenericson.com
 *
 * Generated on 2017-09-05 using @14four/generator-excalibur 0.1.23
 * Converted to ES6 on 2023-12-03 using ChatGPT
 */
class ProfileDetail {
  constructor(element) {
    this.$el = $(element);
    this.setupBinds();
  }

  setupBinds() {
    this.$el.find('.email-link').on('click', this.onEmailClick.bind(this));
  }

  onEmailClick(e) {
    kill(e);
    const $target = $(e.currentTarget);
    const link = $target.attr('href');
    emitter.emit('showDisclaimer', { link });
  }
}

export default ProfileDetail;
